// extracted by mini-css-extract-plugin
export default {"separator":"style-module--separator--e+BAT","maxDay":"style-module--maxDay--djm8S"};